import script from "./UploadShareholder.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadShareholder.vue?vue&type=script&setup=true&lang=js"

import "./UploadShareholder.vue?vue&type=style&index=0&id=611e3548&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-611e3548"]])

export default __exports__